import { checkAndGetArray } from 'src/common/helpers/array-helper';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { store } from 'src/common/redux/configure-store';
import { printReceipts } from 'src/devices/printer-operations';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { closeDrawer } from '../components/cash-drawer-actions';
import { postTillClosing } from './services/post-till-closing';

export const processTillClosing = async (): Promise<void> => {
  const accountId: string =
    store.getState().touchPoint.touchPointConfiguration.accountExternalId ?? '';
  await postTillClosing(accountId)
    .then(
      async (receipts: IReceipt[]): Promise<void> => {
        if (receipts && receipts.length > 0) {
          await printReceipts(checkAndGetArray(receipts)).catch(popupMessage);
        }
        closeDrawer();
        await getTouchPointNotifications();
      },
    )
    .catch(err => {
      popupMessage(err);
    });
};
